import { SkeletonProps } from '@mui/material/Skeleton';
import Typography, { TypographyProps } from '@mui/material/Typography';


import { makeStyles } from 'tss-react/mui';


export type LoadableTypographyProps = TypographyProps<React.ElementType> & {
  width?: SkeletonProps['width'];
  loading?: boolean;
  loadUndefinedChildren?: boolean;
};


const useStyles = makeStyles<Partial<LoadableTypographyProps>>()((_theme, { width }) => ({
  root: {
    display: 'inline-block',
  },

  loader: {
    transformOrigin: '50% 30%',
    transform: 'scale(1, 0.64)',
    position: 'relative',
    borderRadius: '4px',
    color: 'transparent',
    width: width,

    background: 'linear-gradient(to left, rgba(0,0,0,0) 25%, rgba(255, 255, 255, 0.6) 50%, rgba(0,0,0,0) 75%, rgba(0,0,0,0) 100%)',
    // backgroundColor: theme.palette.grey[300],
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    backgroundSize: '400% 400%',
    animation: '$loading 1s linear infinite',
  },

  '@keyframes loading': {
    '0%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    },
  },
}));

export const LoadableTypography: React.FC<LoadableTypographyProps> = ({ children, width, loading, loadUndefinedChildren = false, ...props }) => {
  const { classes, cx } = useStyles({ width });

  if ((!loadUndefinedChildren && children === undefined) || loading === true) {
    return (<Typography {...props} className={cx(classes.root, classes.loader)}>.</Typography>);
  }

  return (
    (
      <Typography {...props} className={cx(classes.root, props.className)}>
        {children}
      </Typography>
    )
  );
};
